import { render, staticRenderFns } from "./LicitacaoMensagemCerca.vue?vue&type=template&id=d6510a46&scoped=true"
import script from "./LicitacaoMensagemCerca.vue?vue&type=script&lang=js"
export * from "./LicitacaoMensagemCerca.vue?vue&type=script&lang=js"
import style0 from "./LicitacaoMensagemCerca.vue?vue&type=style&index=0&id=d6510a46&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6510a46",
  null
  
)

export default component.exports